/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const MoveDownRight = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M19 13V19H13" }],
    ["path", { d: "M5 5L19 19" }]
  ]
];

export { MoveDownRight as default };
//# sourceMappingURL=move-down-right.js.map
